import { Form, FormInput, FormInputType } from 'components/generic/Form';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { educationMaterialEpisodeTitle } from 'utils/yup-validations';

export interface CreateEducationEpisodeFormProps {
  title: string;
  position: number;
  onChange: (values: any) => void;
  onValidityChange: (isValid: boolean) => void;
}
export type CreateEducationEpisodeFormInputs = {
  title: string;
  position: number;
  submit: any;
};

export const CreateEducationEpisodeForm: FC<CreateEducationEpisodeFormProps> = (
  props: CreateEducationEpisodeFormProps
): JSX.Element => {
  const { title, position, onChange, onValidityChange } = props;
  const { t } = useTranslation();

  const inputs: FormInput[] = [
    {
      name: 'title',
      label: t('education.createEpisode.title'),
      validation: educationMaterialEpisodeTitle,
      type: FormInputType.TEXT_FIELD,
      disabled: false,
    },
    {
      name: 'position',
      label: t('education.createEpisode.position'),
      validation: '',
      type: FormInputType.NUMBER,
      disabled: false,
    },
  ];

  const initialValues = { title, position, submit: null };

  return (
    <Form<CreateEducationEpisodeFormInputs>
      inputs={inputs}
      showSubmitBtn={false}
      initialValues={initialValues}
      onValuesChange={onChange}
      onValidityChange={onValidityChange}
      enableReinitialize
    />
  );
};
